export const globalDocumentReferenceApiVersion = 'v2025-02-19'

// TODO: change globalDatasetApiVersion to 'vXXXX-XX-XX' when the global dataset data API is available
export const globalDatasetApiVersion = 'vX'
